import React, { Component } from 'react';
import styled from 'styled-components';
import { locationMovement } from '../../utils/locationMovement';
import TextList from '../text/textList';
import {
  ic_x_gray_24,
} from '../../../public/images/image';

interface Data {
  style: {};
  text: [];
  actionType: string;
  actionData: {};
  imageURL: string,
}

interface Props {
  data: Data;
}

interface State {
  style: {};
  text: [];
  actionType: string;
  actionData: {};
  imageURL: string;
}

const Container = styled.div`
  width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
`;

const Image = styled.img`
  height: calc(100% - 16px);
  padding: 8px 16px;
`;

const Icon = styled.img`
  width: 20px;
  height: 20px;
  position: fixed;
  right: 16px;
`;

class MiniBanner extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      ...props.data,
    };
  }

  render() {
    const {
      style,
      text,
      imageURL,
      actionType,
      actionData,
    } = this.state;

    if (imageURL) {
      return (
        <Container
          className="mini-banner"
          style={style}
          onClick={() => {
            locationMovement(actionType, actionData);
          }}
        >
          <Image src={imageURL} alt="미니 배너 이미지" />
          <Icon
            src={ic_x_gray_24}
            alt="닫기 버튼"
            onClick={(e) => {
              e.target.parentElement.remove();
            }}
          />
        </Container>
      );
    }

    return (
      <Container
        className="mini-banner"
        style={style}
        onClick={() => {
          locationMovement(actionType, actionData);
        }}
      >
        <TextList data={text} />
        <Icon
          src={ic_x_gray_24}
          alt="닫기 버튼"
          onClick={(e) => {
            e.target.parentElement.remove();
          }}
        />
      </Container>
    );
  }
}

export default MiniBanner;
